import { motion } from 'framer-motion'

interface Props {
  accentColor: string
  accentSoft: string
}

const MAPA_LINK = 'https://pay.hotmart.com/V105026857E'

function OffersRepeat({ accentColor, accentSoft }: Props) {

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, delay: 0.2 }}
      className="mt-16 md:mt-20"
    >
      {/* Decorative divider */}
      <div
        className="h-px w-24 mx-auto mb-10"
        style={{
          background: `linear-gradient(90deg, transparent, ${accentSoft}66, transparent)`,
        }}
      />

      {/* Header */}
      <div className="text-center max-w-xl mx-auto mb-10 px-2">
        <p
          className="text-[10px] tracking-[0.4em] uppercase font-body mb-5"
          style={{ color: accentSoft }}
        >
          Pronto para começar?
        </p>
        <h3 className="font-display type-section text-[var(--ink,#e8e0d5)]">
          Escolha seu{' '}
          <em className="italic font-light" style={{ color: accentSoft }}>
            caminho
          </em>
        </h3>
      </div>

      <div className="flex flex-col gap-6 md:gap-8">

        {/* ── OFERTA — MAPA ── */}
        <div
          className="rounded-sm p-5 sm:p-6 md:p-10 relative overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.01) 100%)',
            border: '1px solid rgba(255,255,255,0.08)',
          }}
        >
          {/* Side accent bar */}
          <div
            className="absolute left-0 inset-y-0 w-[3px] rounded-l-sm"
            style={{
              background: `linear-gradient(180deg, ${accentColor}88, ${accentSoft}44, transparent)`,
            }}
          />

          {/* Badge */}
          <div className="flex items-center gap-3 mb-7">
            <span
              className="text-[10px] tracking-[0.4em] uppercase font-body px-3 py-1 rounded-full"
              style={{
                color: accentSoft,
                border: `1px solid ${accentSoft}44`,
                background: `${accentColor}0e`,
              }}
            >
              Oferta <span className="numerals">1</span>
            </span>
            <div
              className="flex-1 h-px"
              style={{
                background: `linear-gradient(90deg, ${accentSoft}44, transparent)`,
              }}
            />
          </div>

          <h2 className="font-display type-section text-[var(--ink,#e8e0d5)] mb-6">
            Mapa de Cura dos{' '}
            <em className="italic font-light" style={{ color: accentSoft }}>
              <span className="numerals">4</span> Elementos
            </em>
          </h2>

          <p className="font-body type-body mb-8" style={{ color: 'rgba(232,224,213,0.65)' }}>
            O Mapa vai à raiz de todos os seus <span className="numerals">4</span> elementos. Você recebe um diagnóstico completo com seus padrões limitantes, sua Trindade de Cura personalizada e seus Decretos Eu Sou escritos especificamente para você.
          </p>

          {/* Price + CTA */}
          <div
            className="pt-7 border-t"
            style={{ borderColor: `${accentSoft}22` }}
          >
            <p
              className="font-display text-[20px] sm:text-[22px] md:text-[28px] leading-none mb-6"
              style={{ color: accentSoft }}
            >
              <span className="text-[var(--ink,#e8e0d5)] numerals">R$147</span>
              <span className="font-body ml-2" style={{ fontSize: '1rem', color: 'rgba(232,224,213,0.55)', fontWeight: 400 }}>
                ou <span className="numerals">12x</span> de <span className="numerals">R$15,20</span>
              </span>
            </p>

            <a
              href={MAPA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full text-center btn-primary px-4 sm:px-8 py-4 min-h-[52px] rounded-sm type-button tracking-[0.1em] sm:tracking-[0.15em] uppercase"
            >
              Quero meu Mapa de Cura
            </a>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default OffersRepeat
